import { render, staticRenderFns } from "./AccessAuthorityAddEmployee.vue?vue&type=template&id=974f00e6"
import script from "./AccessAuthorityAddEmployee.vue?vue&type=script&lang=js"
export * from "./AccessAuthorityAddEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports